import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';

// Jira issue keys look like PROG-12369. Same rule as JIRA_KEY_RE in TestExecution.js and the STR
// Generator workflow, so a key accepted here is one the rest of the tooling accepts too
export const EPIC_KEY_PATTERN = /^[A-Z][A-Z0-9]+-\d+$/;

export function normalizeEpicKey(value) {
  return value.trim().toUpperCase();
}

function EpicPicker({ initialValue = '', onSubmit, compact = false }) {
  const [value, setValue] = useState(initialValue);
  const [invalid, setInvalid] = useState(false);

  // Follow the loaded epic when it changes from outside (back/forward, a shared link)
  useEffect(() => {
    setValue(initialValue);
    setInvalid(false);
  }, [initialValue]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const epicKey = normalizeEpicKey(value);
    if (!EPIC_KEY_PATTERN.test(epicKey)) {
      setInvalid(true);
      return;
    }
    setInvalid(false);
    onSubmit(epicKey);
  };

  return (
    <form className={`str-epic-picker${compact ? ' str-epic-picker-compact' : ''}`} onSubmit={handleSubmit} role="search">
      <label htmlFor="str-epic-input" className="str-epic-picker-label">
        Epic key
      </label>
      <div className="str-epic-picker-row">
        <input
          id="str-epic-input"
          className="str-epic-input"
          type="text"
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            setInvalid(false);
          }}
          placeholder="e.g. PROG-12369"
          autoComplete="off"
          spellCheck={false}
          aria-invalid={invalid}
          aria-describedby={invalid ? 'str-epic-error' : undefined}
        />
        <button type="submit" className="str-epic-submit">
          <Search size={16} /> {compact ? 'Load' : 'Load report'}
        </button>
      </div>
      {invalid && (
        <p id="str-epic-error" className="str-epic-error" role="alert">
          Enter a Jira epic key like PROG-12369.
        </p>
      )}
    </form>
  );
}

export default EpicPicker;
